<script>
import ModalUserComponent from '../../features/modals/ModalUserComponent';
export default {
  name: 'ModalUserView',
  extends: ModalUserComponent,
};
</script>
<template>
  <el-dialog
    v-model="conf.isVisible"
    title="Usuario"
    width="60%"
    class="user-modal"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
  >
    <el-form
      ref="formData"
      v-loading="conf.isLoading"
      :model="formData"
      :rules="rules"
      status-icon
      :label-position="'top'"
    >
      <fieldset>
        <legend>Información de Cuenta</legend>
        <el-row
          class="row-bg"
          :gutter="10"
        >
          <el-col
            :xs="24"
            :sm="8"
            :md="8"
            :lg="8"
            :xl="4"
          >
            <el-form-item
              label="Role"
              prop="role"
            >
              <el-select
                v-model="formData.role"
                clearable
                filterable
                remote
                :remote-method="onSearchRoles"
                placeholder="Seleccionar"
                value-key="id"
                size="small"
              >
                <el-option
                  v-for="item in roles"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
              
          <el-col
            :xs="24"
            :sm="8"
            :md="8"
            :lg="8"
            :xl="10"
          >
            <el-form-item
              label="Nombre(s)"
              prop="firstName"
            >
              <el-input
                v-model="formData.firstName"
                maxlength="70"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="8"
            :md="8"
            :lg="8"
            :xl="10"
          >
            <el-form-item
              label="Apellido(s)"
              prop="lastName"
            >
              <el-input
                v-model="formData.lastName"
                maxlength="70"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          class="row-bg"
          :gutter="20"
        >
          <el-col
            :xs="24"
            :sm="16"
            :md="16"
            :lg="16"
            :xl="18"
          >
            <el-form-item
              label="Correo Electronico"
              prop="email"
            >
              <el-input
                v-model="formData.email"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="8"
            :md="8"
            :lg="8"
            :xl="4"
          >
            <el-form-item
              label="Estado"
              prop="status"
            >
              <el-switch
                v-model="formData.status"
                style="display: block"
                active-color="#13ce66"
                inactive-text="Inactivo"
                active-text="Activo"
                :inactive-value="1"
                :active-value="2"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-if="formData.id"
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-checkbox v-model="updatePassword">
              Actualizar password
            </el-checkbox>
          </el-col>
        </el-row>
        <el-row
          class="row-bg"
          :gutter="20"
        >
          <el-col
            :xs="24"
            :sm="8"
            :md="8"
            :lg="8"
            :xl="8"
          >
            <el-form-item
              label="Usuario"
              prop="userName"
            >
              <el-input
                v-model="formData.userName"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="8"
            :md="8"
            :lg="8"
            :xl="8"
          >
            <el-form-item
              label="Contraseña:"
              prop="password"
            >
              <el-input
                v-model="formData.password"
                size="small"
                type="password"
                placeholder="Contraseña"
                :disabled="!isPasswordRequired()"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="8"
            :md="8"
            :lg="8"
            :xl="8"
          >
            <el-form-item
              label="Verificar Contraseña:"
              prop="checkPass"
            >
              <el-input
                v-model="formData.checkPass"
                size="small"
                type="password"
                placeholder="Verificar Contraseña"
                :disabled="!isPasswordRequired()"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </fieldset>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="small"
          class="btn-cancel"
          @click="onCancel"
        >Cancelar</el-button>
        <el-button
          type="primary"
          class="btn-primary"
          size="small"
          @click="onSubmitForm('formData')"
        >Guardar</el-button>
      </span>
    </template>
  </el-dialog>
</template>
